import React from 'react';
import strings from "../../../components/Language/index.js";

import './listitems.scss';


import axios from 'axios';
import { api } from '../../../components/config/api.js';
import { getToken, storeUserData } from '../../../components/Util/index.js';
import _, { set } from 'lodash';

import { io } from "socket.io-client";
import LoaderContext from '../../../components/Loader/LoaderContext.js';
import BotCard from '../../../components/BotCard';
class BOLLBot extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            botLiveData: [],
            data: [],
            pariNames: "",
            get_live_bot: false,
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                this.getData();
            });

            try {
                var self = this;
                self.socket = io.connect('https://price.ctsbot.com');
                self.socket.on('connect', function (data) {
                });
                self.socket.on('price', function (data) {
                    self.setState({
                        botLiveData: data,
                        get_live_bot: true,
                    })
                });
            }
            catch (e) {
            }
        }
    }

    componentWillUnmount() {
        if (this.liveDataInterval) {
            clearInterval(this.liveDataInterval);
        }
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        setLoading(true);
        if (self.state.access_token) {
            axios({
                method: 'GET',
                url: api.botb_report_active,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                
                    var parinames = "";
                    var parinamesArray = [];
                    var botData = _.filter(ress.data.data, function (o) {
                        o.average_ = (o.total_usdt_cost > 0) ? (o.total_usdt_qty / o.total_usdt_cost) : 0;
                        o.is_calculate = (o.total_usdt_cost > 0) ? true : false;

                        if (o.total_usdt_cost > 0 && o.pair.name && parinamesArray.indexOf(o.pair.name) == -1) {
                            if (parinames) {
                                parinames += `,`;
                            }
                            parinames += `"` + o.pair.name + `"`;
                            parinamesArray.push(o.pair.name);
                        }

                        return o.total_usdt_cost > 0;
                    });
                    self.setState({ data: botData, pariNames: parinames });

                    if (parinames && parinames.length != 0) {
                        self.getLiveData();
                        if (self.liveDataInterval) {
                            clearInterval(self.liveDataInterval);
                        }
                        self.liveDataInterval = setInterval(() => {
                            self.getLiveData();
                        }, 5000);
                    } else {
                        setLoading(false);
                    }

                } else {
                    setLoading(false);
                }
            }).catch(function (e) {
                // toast.error(e.message);
                setLoading(false);
            });
        }
    };

    getLiveData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            var API = api.marketData;
            axios({
                method: 'GET',
                url: API,
                headers: {
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress && ress.status == 200) {
                    _.filter(self.state.data, function (o) {
                        var finalLiveData = _.find(ress.data, { symbol: o.pair.name });
                        if (finalLiveData) {
                            o.liveData = finalLiveData;
                            o.lastPrice = finalLiveData.lastPrice;
                        }
                        return o;
                    })
                    self.setState({ get_live_bot: true });
                }
                self.setState({ is_load: false });
                setTimeout(() => {
                    setLoading(false);
                });
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    render() {
        return (
            <>
                {
                    this.state.data.length === 0 ? <h5 className='text-danger text-center mt-2'>{strings.no_record_found}</h5> : null
                }
                {
                    this.state.data.map((item, i) => {
                        const symbolName = (item.pair && item.pair.name) ? item.pair.name : "";
                        const socketPrice = (this.state.botLiveData && this.state.botLiveData[symbolName] != null) ? parseFloat(this.state.botLiveData[symbolName]) : null;
                        const livePrice = (socketPrice != null && !isNaN(socketPrice)) ? socketPrice : item.lastPrice;
                        return <BotCard key={i + 901} to={{ pathname: `/cts-bot/${item._id}` }} item={item} livePrice={livePrice} ready={this.state.get_live_bot} />;
                    })
                }
            </>
        );
    }
}

export default BOLLBot;
